module.exports = __webpack_public_path__ + "static/img/7.032f1cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/eng/7.png
// module id = Ma92
// module chunks = 0